module.exports = __webpack_public_path__ + "img/career-backend.62fdd441.png";